/* ==========================================================================
   Hattie B's Boutique - shared redesign helpers.

   Deliberately small and observer-free. An earlier build used a
   MutationObserver that re-rendered the cart on every DOM change and blanked
   the storefront; cart refreshes here are explicit and event-driven.
   ========================================================================== */
(function () {
  "use strict";

  var HB = (window.HB = window.HB || {});

  HB.moneyFormat =
    (window.theme && window.theme.moneyFormat) || "${{amount}}";

  /* Format a price given in cents using the shop's money format. */
  HB.formatMoney = function (cents) {
    var value = (Number(cents) || 0) / 100;
    var formatted = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return HB.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, formatted);
  };

  /* Read the current cart. Returns a promise resolving to the cart object. */
  HB.getCart = function () {
    return fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + "cart.js"
      : "/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  };

  /* Subscribe to cart changes without polling or observing the DOM.
     The theme dispatches these when its ajax cart updates. */
  HB.onCartChange = function (handler) {
    ["cart:updated", "cart:build", "ajaxProduct:added"].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        handler(e && e.detail ? e.detail : null);
      });
    });
  };

  HB.prefersReducedMotion = function () {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  };

  /* App embeds (Essential Apps and similar) inject a "30-Day Money Back"
     line and extra card marks under Add to Cart. Those are not in the
     theme files, so hide them on mobile PDP only. Our own 30-day copy
     lives in .hb-m and is left alone. */
  function hideLeftoverPdpClaims() {
    if (!window.matchMedia || !window.matchMedia("(max-width: 767px)").matches) {
      return;
    }
    if (!document.body.classList.contains("template-product")) return;

    var root =
      document.querySelector(".hb-pdp-m") ||
      document.querySelector("[data-section-type='product']");
    if (!root) return;

    var banned = /30[-\s]?day money back|free ups shipping/i;
    root.querySelectorAll("p, div, span, li").forEach(function (el) {
      if (el.closest(".hb-m, .site-header, .site-footer, .hb-footer")) return;
      var text = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (text.length > 0 && text.length < 120 && banned.test(text)) {
        el.style.setProperty("display", "none", "important");
      }
    });

    root.querySelectorAll("[data-essential-cart-element]").forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideLeftoverPdpClaims);
  } else {
    hideLeftoverPdpClaims();
  }
  window.addEventListener("load", hideLeftoverPdpClaims);
})();
